var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.name == 'ActiveInfo' ||
    _vm.name == 'Register' ||
    _vm.name == 'Sign' ||
    _vm.name == 'Scancode' ||
    _vm.name == 'Myactive' ||
    _vm.name == 'UserInfo' ||
    _vm.name == 'Protocol' ||
    _vm.name == 'Policy'
    )?_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","left-arrow":"","fixed":true,"z-index":"999"},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }